import DataReportBlock from '../../../reporter/report/DataReportBlock';
import ToggleConfig from '../../../config/ToggleConfig';
import filterEventPII from './filterEventPII';
import { TransferRecord } from '../../../webrtc/agent/interfaces';

export default function filterTransfers(
  report: DataReportBlock<TransferRecord>,
  toggle: ToggleConfig
): DataReportBlock<TransferRecord> {
  const data = report.data.map(d => filterEventPII(d, toggle));
  return new DataReportBlock({ data });
}
